var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48318 7.2865C9.45231 7.21636 9.38394 7.17086 9.30813 7.17L3.19188 7.17C3.11607 7.17086 3.04769 7.21636 3.01682 7.2865C2.98595 7.35664 2.99824 7.43856 3.04828 7.49625L6.10641 10.9357C6.14319 10.9766 6.19533 11 6.25 11C6.30468 11 6.35682 10.9766 6.39359 10.9357L9.45172 7.49625C9.50176 7.43856 9.51405 7.35664 9.48318 7.2865Z",
    fill: "#BEBEC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01682 4.7135C3.04769 4.78364 3.11606 4.82914 3.19187 4.83H9.30812C9.38393 4.82914 9.45231 4.78364 9.48318 4.7135C9.51405 4.64336 9.50176 4.56144 9.45172 4.50375L6.39359 1.06435C6.35681 1.02336 6.30467 1 6.25 1C6.19532 1 6.14318 1.02336 6.10641 1.06435L3.04828 4.50375C2.99824 4.56144 2.98595 4.64336 3.01682 4.7135Z",
    fill: "#BEBEC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputicon);
export default __webpack_public_path__ + "static/media/inputicon.fa7d7cb3.svg";
export { ForwardRef as ReactComponent };